import request from "@/service";

// 热门搜索分页
export function hotPage(data) {
  return request({
    url: `/sys/hot/search/page`,
    method: "get",
    params: data
  });
}

/* 新增 */
export function hotSave(data) {
  return request({
    url: `/sys/hot/search/save`,
    method: "post",
    data
  });
}

/* 修改 */
export function hotUpdate(data) {
  return request({
    url: `/sys/hot/search/update`,
    method: "put",
    data
  });
}

/* 上下线 */
export function hotOnline(data) {
  return request({
    url: `/sys/hot/search/online`,
    method: "put",
    data
  });
}

/* 删除 */
export function hotDelete(data) {
  return request({
    url: `/sys/hot/search/delete`,
    method: "delete",
    data
  });
}

/* 拖拽*/
export function hotDrag(data) {
  return request({
    url: `/sys/hot/search/drag`,
    method: "put",
    data
  });
}
